import { apiClient } from "../apiClient";
import { BACKEND_ENDPOINTS } from "../apiEndpoints";

export const getCardPaymentFormToken = (userId, planTitle) =>
  apiClient.post(
    `${BACKEND_ENDPOINTS.BASE_URL}${BACKEND_ENDPOINTS.GET_FORM_TOKEN}`,
    { userId, planTitle },
    { headers: { "Content-Type": "application/json" } },
  );

export const recordCardTransaction = ({ userId, selectedPlan, paymentData }) =>
  apiClient.post(
    `${BACKEND_ENDPOINTS.BASE_URL}${BACKEND_ENDPOINTS.RECORD_TRANSACTION}`,
    {
      userId,
      selectedPlan,
      paymentData,
    },
    { headers: { "Content-Type": "application/json" } },
  );
